import TableButton from '@/components/Table/TableButton.vue'

export default function install (app:any) {
  app.component('TableButton', TableButton)
}
